import { useOpacityToggle } from '@amusnet/react-ui'
import React, { useRef, useEffect } from 'react'
import { useConfigurationStore, useSpinButtonSectionStore } from '@stores'
import { ChangeOpacityComponents, ViewportType } from 'game-ui-types'

export interface StopButtonProps {
    onClick: () => void
}

const StopButton: React.FC<StopButtonProps> = ({ onClick }: StopButtonProps) => {
    const shouldUseDynamicStopButtonSize = useConfigurationStore((state) => state.shouldUseDynamicStopButtonSize)
    const numReels = useConfigurationStore((state) => state.numReels)
    const viewport = useConfigurationStore((state) => state.viewport)

    let styles, position

    if (shouldUseDynamicStopButtonSize) {
        const reel = useConfigurationStore((state) => state.reel[viewport])
        const resolutionMultiplier = viewport === ViewportType.DESKTOP ? 1.3334 : 1
        const width = numReels * (reel.width + reel.reelSpacing) * resolutionMultiplier - reel.reelSpacing
        const height = reel.height * resolutionMultiplier
        const reelX = reel.x * resolutionMultiplier
        const reelY = reel.y * resolutionMultiplier

        position = {
            top: `${reelY}px`,
            left: `${reelX}px`,
            width: `${width}px`,
            height: `${height}px`,
        }

        styles = `bg-black fixed z-[0]`
    } else {
        const getComponentConfig = useConfigurationStore((state) => state.getComponentConfig)
        const config = getComponentConfig('StopButton')

        styles = config.styles
        position = config.position
    }

    const updateIsStopButtonInteractive = useSpinButtonSectionStore((state) => state.updateIsStopButtonInteractive)
    const isStopButtonInteractive = useSpinButtonSectionStore((state) => state.isStopButtonInteractive)

    const stopButtonComponent = useRef<HTMLDivElement | null>(null)

    const { isComponentInteractive } = useOpacityToggle(
        ChangeOpacityComponents.STOP_BUTTON,
        stopButtonComponent,
        0,
        isStopButtonInteractive
    )

    useEffect(() => {
        updateIsStopButtonInteractive(isComponentInteractive)
    }, [isComponentInteractive])

    return <div onClick={onClick} className={`${styles}`} style={{ ...position }} ref={stopButtonComponent}></div>
}

export default StopButton
